import React from 'react';

export function usePrevious<T>(value: T) {
  // create a new reference
  const ref = React.useRef<T | undefined>(undefined);

  // store current value in ref
  React.useEffect(() => {
    ref.current = value;
  }, [value]); // only re-run if value changes

  // return previous value (happens before update in useEffect above)
  return ref.current;
}
